import type { ConfigResolver } from '../../config/unified/ConfigResolver';
import { matchesUrlPattern } from './urlUtils';

export function isSpaHandlingEnabledForConfig(
    spaConfig: ConfigResolver['traffic_control']['spa_widget_handling'] | null | undefined,
    currentUrl?: string
): boolean {
    if (!spaConfig?.enabled) {
        return false;
    }

    const patterns = spaConfig.url_patterns;
    if (!patterns || patterns.length === 0) {
        return true;
    }

    const url = currentUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (!url) {
        return false;
    }

    return patterns.some((pattern) => matchesUrlPattern(url, pattern));
}
